import _ from 'lodash'
import { constantsGraphql } from 'utils/constants/constants'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import { timeslotKindExceptionAvailableForConstants } from 'utils/constants/timeslot-kind-esception-constants'

export const parseHelperTimeslotKindOptions = ( timeslotKind ) => {
	// Get the employee
	const employee = store.getState().data[ dataConstants.EMPLOYEE ];
	
	// Get the options
	let results = parseOptions( timeslotKind )
	
	const exceptions = _.get( timeslotKind, 'exceptions', {} );
	if( _.size( exceptions ) > 0 ) {
		_.forEach( exceptions, exception => {
			let foundEmployeeException = false;
			
			switch( exception.available_for ) {
				case timeslotKindExceptionAvailableForConstants.EMPLOYEE:
					// Look for employee guid in employees list
					if( !_.isEmpty( _.find( exception?.employees, { guid: employee?.guid }) ) ) {
						foundEmployeeException = true;
					}
					break;
					
				case timeslotKindExceptionAvailableForConstants.TEAM:
					// Look for employee team guid in employees list
					if( !_.isEmpty( _.find( exception?.teams, { guid: employee?.team?.guid }) ) ) {
						foundEmployeeException = true;
					}
					break;

				case timeslotKindExceptionAvailableForConstants.JOBTITLE:
					// Look for employee jobtitle guid in employees list
					if( !_.isEmpty( _.find( exception?.jobtitles, { guid: employee?.jobtitle?.guid }) ) ) {
						foundEmployeeException = true;
					}
					break;
			}
			
			if( foundEmployeeException === true ) {
				
				// Exceptions do not have all the options available.. we have to filter those out...
				const updatedException = _.omit( exception, [
					'can_overlap_with_booking',
					'can_only_select_one_per_day'
				])
				
				results = parseOptions( updatedException, results )
			}
		})
	}
	
	return results;
}

const optionList = [
	{
		path: 'can_book_from',
		param: 'canBookFrom',
		default: 'always'
	},
	{
		path: 'can_book_until',
		param: 'canBookUntil',
		default: 'always'
	},
	{
		path: 'can_cancel_until',
		param: 'canCancelUntil',
		default: 'always'
	},
	{
		path: 'can_overlap_with_booking',
		param: 'canOverlapWithBooking',
		default: constantsGraphql.YES
	},
	{
		path: 'can_only_select_one_per_day',
		param: 'canOnlySelectOnePerDay',
		default: constantsGraphql.NO
	},
]

const defaultOptions = () => {
	const result = {};
	_.forEach( optionList, option => {
		result[ option.param ] = option.default;
	});
	
	return result;
}

const parseOptions = ( item, currentOptions = undefined ) => {
	const result = currentOptions ?? defaultOptions()
	
	_.forEach( optionList, option => {
		const value = _.get( item, option.path, null );
		if( value !== null ) {
			result[ option.param ] = value;
		}
	})
	
	return result;
}
